import React from 'react';
import { withRouter } from 'react-router-dom';
// ANTD
import Result from 'components/common/Result';
// ANTD
import Row from 'antd/lib/row';
import Button from 'antd/lib/button';

class CantFindContract extends React.PureComponent {
  onClick = () => {
    if (this.props.history.goBack) {
      this.props.history.goBack();
    }
  };

  render() {
    return (
      <Row type="flex" align="middle" justify="center" style={{ flex: 1, height: '100%' }}>
        <div style={{ width: 400, height: 300, maxWidth: '100%' }}>
          <Result
            type="error"
            title={"We can't find this contract!"}
            description="Are you sure the link is correct?"
            actions={(
              <Button type="primary" size="small" onClick={this.onClick}>
                Go Back
              </Button>
            )}
          />
        </div>
      </Row>
    );
  }
}

export default withRouter(CantFindContract);



// WEBPACK FOOTER //
// ./src/routes/contract-sign/CantFindContract/index.js